module.exports = __webpack_public_path__ + "32cbb9fe45fd0f566bff5b336d3f1f52.png";